import { useEffect, useState } from 'react';
import axios from 'axios';
import styles from './Panel.module.css';

import Title from '../../components/Title';
import ButtonLink from '../../components/ButtonLink';

export default function Panel() {
  const [eventsData, setEventsData] = useState([]);
  const [futureEventsCount, setFutureEventsCount] = useState(0);
  
  useEffect(() => {
    axios.get(`https://back-cultura-sje-production.up.railway.app/eventos`)
      .then((response) => {
        const allEvents = response.data;
        setEventsData(allEvents);

        const now = new Date();
        const upcomingEvents = allEvents.filter(event => {
          const eventDate = new Date(event.data);
          return eventDate > now;
        });

        setFutureEventsCount(upcomingEvents.length);
      })
      .catch((error) => {
        console.error('Erro ao buscar evento', error);
      });
  }, []);

  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <Title color='var(--brown-300)'>Painel - Administrativo</Title>

        <div className={styles.cardContainer}>
          <div className={styles.card}>
            <h2>Eventos registrados</h2>
            <p>{eventsData.length}</p>
          </div>
          <div className={styles.card}>
            <h2>Eventos futuros</h2>
            <p>{futureEventsCount}</p>
          </div>
        </div>

        <div className={styles.opcoes}>
          <ButtonLink type='type2' path='/criar-evento'>Criar novo evento</ButtonLink>
          <ButtonLink type='type2' path='/artistas'>Artistas</ButtonLink>
        </div>
      </div>
    </main>
  )
}
